import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, BadgeCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";
import { TenXBrandFooter } from "@/components/TenXBrandFooter";

export default function VerifyBadge() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/badge/${token}`).then(({ data }) => setData(data)).catch(() => setError(true));
  }, [token]);

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="border-b border-border px-6 py-4"><Link to="/" data-testid="badge-home-link"><Logo /></Link></header>
      <main className="flex flex-1 items-center justify-center px-5 py-16">
        {error ? (
          <p className="text-sm text-slate-500" data-testid="badge-not-found">This badge link is invalid or was revoked.</p>
        ) : !data ? (
          <Loader2 className="h-6 w-6 animate-spin text-brand-ink" />
        ) : (
          <div className="w-full max-w-lg text-center" data-testid="badge-verify-card">
            <span className="ff-mono text-[10px] font-medium uppercase tracking-[0.16em] text-brand-ink">verified by tenx</span>
            <h1 className="ff-cabinet mt-3 text-3xl font-black uppercase tracking-tight sm:text-4xl">{data.company_name}</h1>
            <div className="mt-6 inline-flex items-center gap-3 rounded-2xl border border-border bg-white px-8 py-6 shadow-[var(--shadow-md)]">
              <BadgeCheck className="h-10 w-10 text-success" strokeWidth={1.5} />
              <div className="text-left">
                <div className="ff-cabinet text-4xl font-black text-brand-ink" data-testid="badge-streak-months">{data.streak_months}</div>
                <div className="ff-mono text-[10px] uppercase tracking-[0.14em] text-muted-foreground">month update streak</div>
              </div>
            </div>
            <p className="ff-manrope mt-5 text-sm font-medium text-slate-600">
              This founder has published investor updates {data.streak_months > 0 ? `for ${data.streak_months} consecutive month${data.streak_months === 1 ? "" : "s"}` : "on TenX"} - {data.total_updates} update{data.total_updates === 1 ? "" : "s"} total, verified from publish timestamps.
            </p>
            <div className="mx-auto mt-6 flex max-w-sm justify-center gap-1.5" data-testid="badge-month-grid">
              {data.months.map((m) => (
                <div key={m.month} title={m.month}
                    className={`h-6 w-6 rounded ${m.published ? "bg-success" : "bg-secondary"}`} />
              ))}
            </div>
              <div className="ff-mono mt-1.5 flex max-w-sm justify-between text-[9px] uppercase text-muted-foreground" style={{ margin: "6px auto 0" }}>
              <span>{data.months[0]?.month}</span><span>{data.months[11]?.month}</span>
            </div>
            <p className="ff-manrope mt-10 text-xs text-slate-500">
              Founders who report with clarity, win trust.{" "}
            <Link to="/" className="font-bold text-brand-ink hover:underline" data-testid="badge-cta">Run your raise on TenX →</Link>
            </p>
          </div>
        )}
      </main>
      <TenXBrandFooter context="verify-badge" />
    </div>
  );
}
